import {ButtonGroup, Menu, MenuItem, closeCurrentDialog} from 'platform/components';
import {Box, HStack, VStack} from 'platform/foundation';

import {useState} from 'react';

import {head, isNil} from 'ramda';

import {EntityResourceIds, RecordIdHttpModel} from '@dms/api/shared';
import i18n from '@dms/i18n';
import {DmsDataGrid} from '@dms/shared';

import {SYNCED_MESSAGE_RECORD_RESOURCES} from '../constants/syncedMessageRecordResources';

const RESOURCE_MENU_WIDTH = 64;

const RESOURCE_MENU_ITEMS: MenuItem[] = SYNCED_MESSAGE_RECORD_RESOURCES.map((resource) => ({
  id: resource.resourceId,
  label: resource.label,
}));

interface AssignRecordDialogProps {
  onConfirm: (recordId: RecordIdHttpModel) => void;
}

export function AssignRecordDialog(props: AssignRecordDialogProps) {
  const [activeResourceId, setActiveResourceId] = useState<EntityResourceIds>(
    EntityResourceIds.businessCase
  );
  const [selectedRowId, setSelectedRowId] = useState<string | null>(null);

  const activeResource = SYNCED_MESSAGE_RECORD_RESOURCES.find(
    (resource) => resource.resourceId === activeResourceId
  );

  const handleResourceChange = (resourceId: string) => {
    const nextResource = SYNCED_MESSAGE_RECORD_RESOURCES.find(
      (resource) => resource.resourceId === resourceId
    );

    if (isNil(nextResource)) {
      return;
    }

    setActiveResourceId(nextResource.resourceId);
    setSelectedRowId(null);
  };

  const handleConfirm = () => {
    if (isNil(selectedRowId)) {
      return;
    }
    props.onConfirm({resourceId: activeResourceId, id: selectedRowId});
  };

  return (
    <VStack height="100%" spacing={4}>
      <HStack height={200} spacing={0} align="stretch">
        <Box
          width={RESOURCE_MENU_WIDTH}
          padding={4}
          borderRight="1px solid"
          borderColor="general.separator"
        >
          <Menu
            items={RESOURCE_MENU_ITEMS}
            activeItemId={activeResourceId}
            onItemChange={handleResourceChange}
            data-testid="emailSynchronization-assignRecord-resourceMenu"
          />
        </Box>

        <Box flex={1} minWidth={0} height="100%" paddingLeft={4}>
          <DmsDataGrid
            key={activeResourceId}
            gridCode={activeResource?.gridCode ?? ''}
            onRowSelectionChange={(rows) => setSelectedRowId(head(rows)?.id ?? null)}
          />
        </Box>
      </HStack>

      <ButtonGroup
        align="right"
        buttons={[
          {
            title: i18n.t('general.actions.cancel'),
            onClick: closeCurrentDialog,
            variant: 'secondary',
          },
          {
            title: i18n.t('general.actions.save'),
            onClick: handleConfirm,
            isDisabled: isNil(selectedRowId),
          },
        ]}
      />
    </VStack>
  );
}
